<template lang="pug">
component(
    :class="[$style.root, $style[`view_${props.view}`]]"
    :disabled="isDisabled"
    v-bind="options"
    
    @click="$emit('click')"
)
    TheText(
        name="buttonM"
        :color="textColor"
    )
        slot
    IconBase(
        v-if="props.icon"
        :class="$style.icon"
        :name="props.icon"
        :color="textColor"
        :size="16"
    )
            

</template>

<script lang="ts">
import { computed, defineComponent, PropType } from 'vue'

import { TheText } from '@/shared/ui/TheText'
import { IconBase, names } from '@/shared/ui/IconBase'
import { TransitionFade } from '@/shared/ui/transitions/TransitionFade'

import { views } from './index'

export type ButtonProps = {
    href: string
    view: (typeof views)[number]
    icon?: (typeof names)[number]
    isDisabled?: boolean
}

export default defineComponent({
    name: 'Button',
    props: {
        href: {
            type: String as PropType<ButtonProps['href']>,
        },
        view: {
            type: String as PropType<ButtonProps['view']>,
            default: 'primary',
        },
        icon: {
            type: String as PropType<ButtonProps['icon']>,
        },
        isDisabled: {
            type: Boolean as PropType<ButtonProps['isDisabled']>,
        },
    },
    setup(props) {
        const options = computed(() => {
            if (props.href) {
                return {
                    is: 'a',
                    href: props.href,
                    target: '_blank',
                    rel: 'noopener noreferrer',
                }
            }
            return {
                is: 'button',
            }
        })

        const textColor = computed(() => {
            return props.view === 'primary'
                ? 'primaryForeground'
                : 'secondaryForeground'
        })

        return {
            props,
            options,
            textColor,
        }
    },
    components: { IconBase, TheText, TransitionFade },
})
</script>

<style module lang="scss" src="./Button.module.scss" />
